import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-950 py-8 border-t border-navy-800" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-47">
        <p className="text-navy-700 text-sm" data-id="element-48">
          &copy; {currentYear} The Secure Woman. All rights reserved.
        </p>
        <div className="mt-4 flex justify-center gap-4 text-xs text-navy-600" data-id="element-49">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-50">
            Terms & Conditions
          </a>
          <span data-id="element-51">|</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-52">
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>;
}